import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfinityScrollComponent } from './infinity-scroll.component';

@NgModule({
  declarations: [InfinityScrollComponent],
  exports: [InfinityScrollComponent],
  entryComponents: [InfinityScrollComponent],
  imports: [CommonModule]
})
export class InfinityScrollModule {}

export { InfinityScrollComponent };
